window.Products.Book.Notebook = function() {};
window.Products.Book.Notebook.inherits(window.Products.Book.Book);
window.Products.Book.Notebook.id = 66;
window.Products.Book.Notebook.slug = 'notebook';
window.Products.Book.Notebook.has_3d = true;
window.Products.Book.Notebook.use_variants = true;
window.Products.Book.Notebook.fit_template_all = true;
window.Products.Book.Notebook.dpi = 300;

window.Products.Book.Notebook.prototype.set3dProperties = function(modelViewer) {
	modelViewer.scene.children[0].intensity = 0.96;
	modelViewer.scene.children[1].intensity = 0.12;
	xRotation = new THREE.Matrix4();
	xRotation.makeRotationAxis(new THREE.Vector3(1, 0, 0).normalize(), 90 * Math.PI / 180);
	xRotation.multiply(modelViewer.object.matrix);
	modelViewer.object.matrix = xRotation;
	modelViewer.object.rotation.setFromRotationMatrix(modelViewer.object.matrix);
	modelViewer.object.position.x = -0.5;
	this.updateThreeTexture(modelViewer);
};

window.Products.Book.Notebook.prototype.setThreeControls = function(controls) {
	controls.minDistance = 25;
	controls.maxDistance = 55;
};

window.Products.Book.Notebook.prototype.updateThreeTexture = function(modelViewer) {
	if(typeof modelViewer.lut == 'undefined'){
		modelViewer.enableLut('textures/lut_bw.png');
	}
	modelViewer.object.children[2].material.map = modelViewer.texture;
	modelViewer.object.children[1].material.map = new THREE.Texture(modelViewer.lut.sourceCanvas);
};

window.Products.Book.Notebook.prototype.update3dModel = function(modelViewer){
	modelViewer.object.children[1].material.map.needsUpdate = true;
};

window.Products.Book.Notebook.prototype.getPageFitDimensions = function(variant, scene){
	var data = this.static.preview_data.scenes[scene].variants[variant];
	var width = 0, height = 0;
	width = data.originalWidth;
	height = data.originalHeight;
	if(scene == 'cover') width *= 2;
	return [width, height];
};